import axios from 'axios';
import API_URL from '../../config/ApiUrl';
import { makeAutoObservable } from 'mobx';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import { Notification, RegionType } from '../../config/Global';

export default class RegionStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	searchValue = '';
	regionType = RegionType.State;
	parentRegionId = '';
	regionList = [];
	regionDetail = null;

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList({
					...payload,
					regionType: this.regionType,
					parentRegionId: this.parentRegionId,
				})
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.REGION.LIST}?regionType=${payload.regionType}&parentRegionid=${encodeURIComponent(payload.parentRegionId)}&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	getRegionList = async (values) => {
		try {
			const { data } = await axios.get(
				`${API_URL.STATE}?regionType=${values}`
			);
			this.regionList = data.data;
			return data.data;
		} catch {}
	};

	addRegion = async (formData) => {
		return await axios
			.post(API_URL.REGION.ADD, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				if (data.httpStatusCode === 200) {
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	deleteRegion = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.REGION.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	ReadRegion = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.REGION.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.regionDetail = data.data;
			return data.data;
		} catch {}
	};

	editRegion = async (formData) => {
		return await axios
			.put(API_URL.REGION.UPDATE, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				if (data.httpStatusCode === 200) {
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
}
